export const LOADING_TICKET = "LOADING_TICKET";
export const GET_TICKET_LIST = "GET_TICKET_LIST";
export const GET_TICKET_ID = "GET_TICKET_ID";
export const REMOVE_TICKET = "REMOVE_TICKET";
export const ADD_TICKET = "ADD_TICKET";
export const UPDATE_TICKET = "UPDATE_TICKET";
export const ADD_COMMENT = "ADD_COMMENT";
export const REMOVE_COMMENT = "REMOVE_COMMENT";
